import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "mt40"
}
const _hoisted_5 = { class: "ml2 w100 mt20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "タイトル", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = { class: "ml2 mt20 w100" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "内容", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_12 = { class: "ml2 w100 mt20" }
const _hoisted_13 = { class: "ml3 fl" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: `can_add_link_`,
  class: "fs12 pointer"
}, " URLリンクボタンを追加", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "fl ml2 w100 mt20" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "fs18 fw600" }, "リダイレクト先を設定", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("完了時に直接遷移させるページを設定できます。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("URLでない場合、完了ページを表示します。")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_CheckboxTag = _resolveComponent("CheckboxTag")!

  return (_ctx.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_SelectTag, {
            name: "display_form_timing_type",
            id: "select_display_form_timing_type",
            class: "fl fs14 roundForm mt20",
            style: {"min-width":"130px","height":"50px","width":"300px"},
            options: _ctx.SelectUtil.thanksPageDisplayTypes.map(t => t.name),
            defaultOption: _ctx.getDefaultThanksPageDisplayType(),
            onSelectValue: _ctx.selectDisplayType
          }, null, 8, ["options", "defaultOption", "onSelectValue"]),
          _hoisted_2
        ]),
        _hoisted_3,
        (_ctx.currentType == `complete`)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_TextfieldTag, {
                  placeholder: `${_ctx.Util.thanksPageDefaultTitle}`,
                  style: {"height":"50px"},
                  class: _normalizeClass(`fl fs14 roundForm mw100`),
                  value: _ctx.room.room_setting && _ctx.room.room_setting.thanks_page ? _ctx.room.room_setting.thanks_page.title : ``,
                  onInputValue: _ctx.inputThanksPageTitle
                }, null, 8, ["placeholder", "value", "onInputValue"]),
                _hoisted_7
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_TextareaTag, {
                  placeholder: `${_ctx.Util.thanksPageDefaultContent}`,
                  style: {"height":"120px"},
                  class: _normalizeClass(`fl fs14 roundForm mw100`),
                  value: _ctx.room.room_setting && _ctx.room.room_setting.thanks_page ? _ctx.room.room_setting.thanks_page.content : ``,
                  onInputValue: _ctx.inputThanksPageContent
                }, null, 8, ["placeholder", "value", "onInputValue"]),
                _hoisted_10
              ]),
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_CheckboxTag, {
                    value: ``,
                    name: `can_add_link`,
                    checked: _ctx.isOpenUrlLink,
                    prefix: `can_add_link`,
                    onClickCheckbox: _ctx.clickAddUrlLink,
                    class: "ml1"
                  }, null, 8, ["checked", "onClickCheckbox"]),
                  _hoisted_14,
                  _hoisted_15
                ]),
                (_ctx.isOpenUrlLink)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createVNode(_component_TextfieldTag, {
                        placeholder: `ボタン名`,
                        style: {"height":"50px"},
                        class: _normalizeClass(`fl fs14 roundForm mw100`),
                        value: 
                            _ctx.room.room_setting && _ctx.room.room_setting.thanks_page ? _ctx.room.room_setting.thanks_page.button_name : ``
                        ,
                        onInputValue: _ctx.inputThanksPageButtonName
                      }, null, 8, ["value", "onInputValue"]),
                      _createVNode(_component_TextfieldTag, {
                        placeholder: `リンク先を設定`,
                        style: {"height":"50px"},
                        class: _normalizeClass(`fl fs14 roundForm mw100`),
                        value: 
                            _ctx.room.room_setting && _ctx.room.room_setting.thanks_page ? _ctx.room.room_setting.thanks_page.button_link : ``
                        ,
                        onInputValue: _ctx.inputThanksPageButtonLink
                      }, null, 8, ["value", "onInputValue"]),
                      _hoisted_17
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_18
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _createVNode(_component_TextfieldTag, {
                  placeholder: `URLを入力`,
                  style: {"height":"50px"},
                  class: _normalizeClass(`fl fs14 roundForm mw100`),
                  value: _ctx.RoomSetting.hasRedirectUrl(_ctx.room) ? _ctx.room.room_setting.thanks_page.redirect_url_after_send : ``,
                  onInputValue: _ctx.inputRedirectUrl
                }, null, 8, ["value", "onInputValue"])
              ])
            ]))
      ]))
    : _createCommentVNode("", true)
}